import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { formatUzs } from '../lib/format';
import { format, parseISO } from 'date-fns';

const UZ_CITIES = ['Toshkent', 'Samarqand', 'Buxoro', 'Andijon', 'Farg\u02bcona', 'Namangan', 'Qarshi', 'Nukus', 'Urganch', 'Termiz'];

export function MarketplacePage() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get('q') ?? '');
  const [city, setCity] = useState(params.get('city') ?? '');

  const { data, isLoading } = useQuery({
    queryKey: ['marketplace', q, city],
    queryFn: () => api.searchWorkshops({ q: q || undefined, city: city || undefined, pageSize: 30 }),
  });

  function apply() {
    const sp = new URLSearchParams();
    if (q) sp.set('q', q);
    if (city) sp.set('city', city);
    setParams(sp);
  }

  return (
    <>
      <h3>🔍 Servis qidirish</h3>
      <div className="field">
        <input
          placeholder="Servis nomi yoki tavsif"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && apply()}
        />
      </div>
      <div className="field">
        <select value={city} onChange={(e) => { setCity(e.target.value); setTimeout(apply, 0); }}>
          <option value="">Barcha shaharlar</option>
          {UZ_CITIES.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>
      <button className="btn btn-primary btn-block" onClick={apply} style={{ marginBottom: 12 }}>
        Qidirish
      </button>

      {isLoading ? (
        <div className="spinner" />
      ) : data && data.items.length > 0 ? (
        data.items.map((w: any) => (
          <Link key={w.id} to={`/marketplace/${w.id}`} className="card" style={{ display: 'block', textDecoration: 'none' }}>
            <div className="row-between" style={{ marginBottom: 6 }}>
              <div style={{ fontWeight: 600, fontSize: 16 }}>{w.name}</div>
              {w.isVerified && <span className="tag success">✓</span>}
            </div>
            <div className="muted" style={{ fontSize: 13, marginBottom: 6 }}>
              📍 {w.address ?? w.city ?? '—'}
            </div>
            {w.description && (
              <div className="muted" style={{ fontSize: 13, marginBottom: 6 }}>
                {w.description.length > 80 ? w.description.slice(0, 80) + '…' : w.description}
              </div>
            )}
            <div className="row" style={{ gap: 6 }}>
              {w.rating > 0 && (
                <span className="tag warning">⭐ {w.rating.toFixed(1)} ({w.reviewsCount})</span>
              )}
              <span className="tag primary">🏢 {w.city ?? '—'}</span>
            </div>
          </Link>
        ))
      ) : (
        <div className="empty">
          <div className="emoji">🔍</div>
          <div>Hech narsa topilmadi</div>
          <div className="muted" style={{ marginTop: 4 }}>Boshqa kalit so'z bilan urinib ko'ring</div>
        </div>
      )}
    </>
  );
}
